<template>
    <el-row type="flex" class="nav-bar--right">

      <el-button class="size12 new-notice" :loading="newLoading" v-if="$permission('dashboard:view')" @click="openNoticeModal">
        新功能
      </el-button>

    <div id="navbar_kefu">
        <gj-icon class="el-icon-service relate-us"></gj-icon>
    </div>
    <message-popover ref="messageNewVal"></message-popover>

      <person-info-popover @cutNavState="cutNavState"></person-info-popover>

<!--      <el-row type="flex" align="middle" class="nav-bar&#45;&#45;right__user">-->

<!--          <gj-dropdown>-->
<!--            <el-row type="flex" align="middle">-->
<!--                <el-avatar size="small" :src="userUrl" class="nav-bar&#45;&#45;right__user&#45;&#45;avatar"></el-avatar>-->
<!--                <span class="nav-bar&#45;&#45;right__user&#45;&#45;name">{{userInfo.name}}</span>-->
<!--            </el-row>-->
<!--            <template #dropdown>-->
<!--                <gj-dropdown-item @click="personalCenter">个人中心</gj-dropdown-item>-->
<!--                <gj-dropdown-item @click="cutNavState">导航布局设置</gj-dropdown-item>-->
<!--                <gj-dropdown-item @click="logout">退出账号</gj-dropdown-item>-->
<!--            </template>-->
<!--          </gj-dropdown>-->
<!--      </el-row>-->
    </el-row>
</template>

<script>
import PersonInfoPopover from "@/views/layout/app-nav-bar/components/person-info-popover";
import MessagePopover from "../../modules/message/bar/message-popover";
import AppCutNavModal from './modal/app-cut-nav-modal.vue'
import {mapGetters} from "vuex";
import {newVersion} from "@/api/message";
import AppVersionAnnouncementModal from "@/views/modules/common/message/modal/version-announcement";
  import {isMeaningfulMixin} from "@/minxins";
export default {
    name: "app-info-bar",
    components: {MessagePopover, PersonInfoPopover },
    mixins: [isMeaningfulMixin],
    data() {
      return {
        userUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        newLoading: false
      }
    },
    computed: {
      ...mapGetters(['userMenus', 'userInfo', 'latestVersionId']),
    },
    methods: {
      // logout() {
      //   //清除缓存
      //   this.$cache.deleteCache();
      //   window.sessionStorage.removeItem('firstIn');
      //   this.$store.dispatch(USER_LOGOUT)
      //     .then(() => {
      //       // 退出登录时将消息数清零,以免登录时重新登录时会记住前一个的记录
      //       this.$store.commit(USER_SET_MESSAGE, {type: 'system', value: 0});
      //       this.$store.commit(USER_SET_MESSAGE, {type: 'account', value: 0});
      //       this.$store.commit(USER_SET_MESSAGE, {type: 'operation', value: 0});
      //       this.$store.commit(USER_SET_POLLING, false);
      //
      //       this.$gjMessage({
      //         message: '退出成功',
      //         type: 'success',
      //         duration: 800
      //       });
      //     })
      //     .catch(() => {
      //       this.$gjMessage.error('退出失败');
      //     })
      // },
      // personalCenter() {
      //   this.$router.push({
      //     path: '/personal-center/personal-center'
      //   })
      // },
      openNoticeModal(row) {
        if(!this.latestVersionId) {
          this.$message.warning("请稍等片刻,新功能公告马上发出!");
          return false
        }
        this.newLoading = true
        newVersion(this.latestVersionId, false).then((res) => {
          this.$gjCreate(AppVersionAnnouncementModal, {
            global: true,
            props: {
              data: res.data
            }
          })
          row.isRead = true
        }).complete(() => { this.newLoading = false })
      },
      // 导航布局设置
      cutNavState() {
        this.$gjCreate(AppCutNavModal, {
          global: true,
          mountTo: document.getElementById('gj-base-main'),
          on: {
            cutNavConfirm: stats => {
              this.cutNavConfirm(stats)
            }
          }
        });
      },
      // 确认
      cutNavConfirm(stats) {
        this.$emit('cutNavState', stats)
      }
    }
}
</script>

<style scoped lang="scss">
.nav-bar--right {
  height: 100%;
  position: relative;
    align-items: center;
  }
  .nav-bar--left__menu {
    border: none !important;
    background: unset;
  }
  .nav-bar--right__notice {
    margin: 8px 22px 5px 0;
    font-size: 23px;
    color: #fff;
  }
  .nav-bar--right__notice /deep/ .el-badge__content {
    height: 14px;
    line-height: 14px;
    padding: 0 4px;
    top: 4px;
  }
  .nav-bar--right__user {
    color: #fff;
  }
  .nav-bar--right__user--avatar {
    height: 24px;
    width: 24px;
  }
  .nav-bar--right__user--name {
    margin: 0 12px;
    color: #fff;
    white-space:nowrap;
  }
  /deep/ .el-tabs__nav-next,
  /deep/ .el-tabs__nav-prev {
    line-height: 32px;
  }
  .relate-us {
    cursor: pointer;
    color: #fff;
    /* margin-right: 14px;
    margin-bottom: 4px; */
    /* font-size: 16px; */
    padding: 0 14px;
  }

  /deep/ .el-badge{
    vertical-align: baseline;
  }
.new-notice{
  cursor: pointer;
  width: 44px;
  height: 29px;
  color: white;
  text-align: center;
  border: none;
  padding: 0;
  padding-top: 5px;
  box-sizing: border-box;
  background: url("~@/assets/images/new-notice.png") 50% 50% no-repeat;
  position: absolute;
  top:0;
  left: -50px;
  &:hover {
    background: url("~@/assets/images/new-notice.png") 50% 50% no-repeat;
    color: #FFFFFF;
    border: none;
  }
  &.is-loading {
    position: absolute;
    width: 66px;
    left: -70px;
  }
}
</style>
